// removed by extract-text-webpack-plugin
module.exports = {"projectName":"_3JSs7QNEkFQf_AXk","projectWrapper":"_2BQiEWF0mWD8cRyG","bars":"_1axqveKKfCRfiZ75","menuContainer":"_1Yw_PexzRR0StNJ2","menu":"rPhCq00nPCPkQZXK","projectNameEditing":"UstOZpl7ZYUp9QBJ","permissionIcon":"_16MuJeOy-sjJ5BHF","project":"_1-LjHLLFZ2_xDBft","addNode":"_1YBZjtuwhCV_I1YJ","hidden":"_1sKln61mhysc2j5C","enter":"_3SJYuGqADBMt91YB","enterActive":"yhCVkSdLh04kxede","leave":"_2kZajVFKZBX7bOog","leaveActive":"_2J2WchYLIxILGaCs","logo":"_635NClyE0I6xNYa7","emptyView":"_2DD-NHFGJQLObkdT","container":"DQqxVZFko5O8NFcy","caption":"_1aTQJ0Xa0P72H6lo","startNewProject":"x8gyjWtgOE9UmJEB"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Projects/ProjectPage.pcss
// module id = 499
// module chunks = 1